import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-shipping-label',
  templateUrl: './shipping-label.component.html',
  styleUrls: ['./shipping-label.component.css']
})
export class ShippingLabelComponent implements OnInit {

  constructor(private g: Globals) {
    this.g.page = "Shipping Label";
  }

  ngOnInit() {
  }

}
